import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { ContractVersionPageContractStatusFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  contractStatus?: ContractVersionPageContractStatusFragment | undefined | null
  isUpcoming?: boolean
}

const getStatusText = (isActive: boolean, isUpcoming: boolean): string => {
  if (isActive) return i18n.t('contract_versions.fix_discontinuous.contract_status.active')

  if (isUpcoming) return i18n.t('contract_versions.navigator.history.status_tag.upcoming')

  return i18n.t('contract_versions.navigator.history.periods.inactivity')
}

const ContractStatus = ({ contractStatus, isUpcoming }: Props) => {
  const isActive = contractStatus?.isActive ?? false
  const status = getStatusText(isActive, isUpcoming ?? false)
  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s2">
      <Box gap="s8">
        <Box flexDirection="row" alignItems="center" gap="s4" height="s24">
          <Text size="200" weight="normal" color="grey800">
            {i18n.t('contract_versions.fix_discontinuous.contract_status.title')}
          </Text>
        </Box>
        {contractStatus ? (
          <Tag
            solid={false}
            inline
            leftItem="circle"
            showCircle
            type={isActive ? 'malibu' : isUpcoming ? 'tangerine' : 'grey5'}
          >
            <Text size="200" weight="medium" color="grey1000" capitalize>
              {status}
            </Text>
          </Tag>
        ) : (
          <Text size="200" weight="medium" color="grey1000">
            {i18n.t('contract_versions.contract_information.not_informed')}
          </Text>
        )}
      </Box>
    </Box>
  )
}

export default ContractStatus
